exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".target-group-title {\n  color: var(--color-mineshaft);\n  font-weight: 600;\n  font-size: 14px;\n  padding-right: 15px;\n  text-transform: uppercase;\n  padding-left: 10px;\n}\n.cluster-container .target-group-container {\n  margin-top: 5px;\n}\n.cluster-container .target-group-container:not(:first-child) {\n  margin-top: 3px;\n  padding-top: 5px;\n}\n.target-group-container .target-group-header {\n  padding: 4px 0;\n}\n.target-group-container .server-group-title {\n  padding-top: 0;\n}\n.target-group-container .server-group-title .clickable-row {\n  margin-top: -1px;\n}\n.target-group-container .no-margin-top {\n  margin-top: -1px !important;\n}\n.target-group-container > div > .text-right {\n  padding-right: 10px;\n  font-weight: 600;\n}\n.listener-targets {\n  display: inline-block;\n  vertical-align: top;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/amazon/src/loadBalancer/targetGroup.less
// module id = 3506
// module chunks = 0